// ── 购物车核心：数据驱动 ──
function formatDrawerMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function showBuyError(message) {
  const el = document.getElementById('tip-buy-error');
  const text = el && el.querySelector('.srl-buy-notice-text');
  if (text) text.textContent = message;
  setBuyTipVisible(el, true);
}

function hideBuyError() {
  setBuyTipVisible(document.getElementById('tip-buy-error'), false);
}

function formatNavBuyLabel(price) {
  if (window.matchMedia('(max-width: 820px)').matches) return 'Buy';
  return `Buy Now — ${price}`;
}

function syncLandingPrices() {
  const priceCents = window.SRL_PRICE_SINGLE_CENTS;
  if (!priceCents) return;

  const price = formatDrawerMoney(priceCents);
  const compareCents = window.SRL_COMPARE_SINGLE_CENTS || priceCents;
  const compare = formatDrawerMoney(compareCents);
  const savePct = calcSavePercent(priceCents, compareCents);

  const navBuy = document.querySelector('.nav-buy');
  if (navBuy) navBuy.textContent = formatNavBuyLabel(price);

  const heroNow = document.querySelector('.hero .price-now');
  const heroWas = document.querySelector('.hero .price-was');
  const heroBadge = document.querySelector('.hero .price-badge');
  if (heroNow) heroNow.textContent = price;
  if (heroWas) heroWas.textContent = compare;
  if (heroBadge && savePct) heroBadge.textContent = `Save ${savePct}%`;

  const finalBtn = document.querySelector('.final .btn-hero');
  if (finalBtn) finalBtn.textContent = `Add to Emergency Kit — ${price} →`;
}

function updateDrawerFooter(cart) {
  const subtotalEl = document.getElementById('srl-cart-subtotal-price');
  const discountRow = document.getElementById('srl-cart-discount-row');
  const discountEl = document.getElementById('srl-cart-discount-price');
  const totalRow = document.getElementById('srl-cart-total-row');
  const totalEl = document.getElementById('srl-cart-total-price');
  const clearBtn = document.getElementById('srl-drawer-clear');
  const checkoutBtn = document.getElementById('srl-btn-checkout');
  const isEmpty = !cart || cart.item_count === 0;

  if (isEmpty) {
    if (subtotalEl) subtotalEl.textContent = '$0.00';
    if (discountRow) discountRow.hidden = true;
    if (totalRow) totalRow.hidden = true;
    if (clearBtn) clearBtn.hidden = true;
    if (checkoutBtn) checkoutBtn.disabled = true;
    return;
  }

  const subtotalCents = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
  const discountCents = cart.total_discount || 0;
  const totalCents = cart.total_price;

  if (discountCents > 0) {
    if (subtotalEl) subtotalEl.textContent = formatDrawerMoney(subtotalCents);
    if (discountRow) discountRow.hidden = false;
    if (discountEl) discountEl.textContent = '−' + formatDrawerMoney(discountCents);
    if (totalRow) totalRow.hidden = false;
    if (totalEl) totalEl.textContent = formatDrawerMoney(totalCents);
  } else {
    if (subtotalEl) subtotalEl.textContent = formatDrawerMoney(totalCents);
    if (discountRow) discountRow.hidden = true;
    if (totalRow) totalRow.hidden = true;
  }

  if (clearBtn) clearBtn.hidden = false;
  if (checkoutBtn) checkoutBtn.disabled = false;
}

function setClearCartLoading(loading) {
  const clearBtn = document.getElementById('srl-drawer-clear');
  const checkoutBtn = document.getElementById('srl-btn-checkout');
  const footer = document.querySelector('.srl-drawer-footer');

  if (clearBtn) {
    clearBtn.disabled = loading;
    clearBtn.classList.toggle('is-loading', loading);
    if (loading) {
      clearBtn.dataset.prevLabel = clearBtn.textContent;
      clearBtn.textContent = 'Clearing…';
    } else if (clearBtn.dataset.prevLabel) {
      clearBtn.textContent = clearBtn.dataset.prevLabel;
      delete clearBtn.dataset.prevLabel;
    }
  }
  if (checkoutBtn && loading) checkoutBtn.disabled = true;
  if (footer) footer.classList.toggle('is-busy', loading);
}

function buildDrawerLimitNoticeHtml() {
  return `
    <div class="srl-buy-notice srl-buy-notice--inline" hidden>
      <div class="srl-buy-notice-inner">
        <span class="srl-buy-notice-dot" aria-hidden="true"></span>
        <div class="srl-buy-notice-body">
          <span class="srl-buy-notice-tag">Single lamp limit reached</span>
          <p class="srl-buy-notice-text">Maximum 2 single lamps per order.</p>
          <button type="button" class="srl-buy-notice-cta" data-action="switch-bundle">Switch to Family Bundle</button>
        </div>
      </div>
    </div>
  `;
}

function buildDrawerItemHtml(item) {
  const imgUrl = item.image ? item.image : '';
  const toastHtml = item.variant_id == variantSingle ? buildDrawerLimitNoticeHtml() : '';
  const unitCents = item.final_price != null ? item.final_price : item.price;
  const lineCents = item.final_line_price != null
    ? item.final_line_price
    : (item.line_price != null ? item.line_price : unitCents * item.quantity);

  return `
    <div class="srl-cart-item" data-line-key="${item.key}" style="flex-wrap: wrap;">
      <img src="${imgUrl}" alt="${escapeHtml(item.product_title)}" class="srl-item-img">
      <div class="srl-item-info">
        <div class="srl-item-title">${escapeHtml(item.product_title)}</div>
        <div class="srl-item-price-row">
          <span class="srl-item-unit">${formatDrawerMoney(unitCents)} × ${item.quantity}</span>
          <span class="srl-item-line-total">${formatDrawerMoney(lineCents)}</span>
        </div>
        <div class="srl-drawer-qty">
          <div class="srl-dq-ctrl">
            <button type="button" class="srl-dq-btn srl-dq-minus" data-key="${item.key}" data-vid="${item.variant_id}" data-qty="${item.quantity - 1}">−</button>
            <span class="srl-dq-num">${item.quantity}</span>
            <button type="button" class="srl-dq-btn srl-dq-plus" data-key="${item.key}" data-vid="${item.variant_id}" data-qty="${item.quantity + 1}">+</button>
          </div>
          <button type="button" class="srl-dq-remove" data-key="${item.key}">Remove</button>
        </div>
      </div>
      ${toastHtml}
    </div>
  `;
}

function patchDrawerItemRow(row, item) {
  const qty = item.quantity;
  const numEl = row.querySelector('.srl-dq-num');
  const minusBtn = row.querySelector('.srl-dq-minus');
  const plusBtn = row.querySelector('.srl-dq-plus');
  const unitEl = row.querySelector('.srl-item-unit');
  const lineTotalEl = row.querySelector('.srl-item-line-total');

  const unitCents = item.final_price != null ? item.final_price : item.price;
  const lineCents = item.final_line_price != null
    ? item.final_line_price
    : (item.line_price != null ? item.line_price : unitCents * qty);

  if (numEl) numEl.textContent = qty;
  if (minusBtn) minusBtn.setAttribute('data-qty', qty - 1);
  if (plusBtn) plusBtn.setAttribute('data-qty', qty + 1);
  if (unitEl) unitEl.textContent = `${formatDrawerMoney(unitCents)} × ${qty}`;
  if (lineTotalEl) lineTotalEl.textContent = formatDrawerMoney(lineCents);

  const notice = row.querySelector('.srl-buy-notice');
  if (notice && item.variant_id == variantSingle && qty < MAX_SINGLE_QTY) {
    notice.hidden = true;
  }
}

function canPatchDrawerItems(container, cart) {
  if (!cart || cart.item_count === 0) return false;

  const existingRows = container.querySelectorAll('.srl-cart-item[data-line-key]');
  if (existingRows.length !== cart.items.length) return false;

  return cart.items.every((item, index) => {
    return existingRows[index].getAttribute('data-line-key') === item.key;
  });
}

function setDrawerLineLoading(row, loading) {
  if (!row) return;

  const ctrl = row.querySelector('.srl-dq-ctrl');
  if (loading) {
    row.querySelectorAll('.srl-dq-btn, .srl-dq-remove').forEach((btn) => { btn.disabled = true; });
    clearTimeout(row._srlLoadingTimer);
    row._srlLoadingTimer = setTimeout(() => {
      if (ctrl) ctrl.classList.add('is-loading');
    }, 150);
    return;
  }

  clearTimeout(row._srlLoadingTimer);
  row._srlLoadingTimer = null;
  if (ctrl) ctrl.classList.remove('is-loading');
  row.querySelectorAll('.srl-dq-btn, .srl-dq-remove').forEach((btn) => { btn.disabled = false; });
}

window.CartBubble = {
  update(cartData) {
    const bubble = document.getElementById('landing-cart-count-bubble');
    const value = document.getElementById('landing-cart-count-value');
    if (!bubble || !value) return;
    if (cartData && cartData.item_count > 0) {
      bubble.style.display = 'flex';
      value.textContent = cartData.item_count;
    } else {
      bubble.style.display = 'none';
    }
    window.renderCartDrawer(cartData);
  }
};

window.renderCartDrawer = function(cart) {
  const container = document.getElementById('srl-cart-items-container');
  if (!container) return;

  if (!cart || cart.item_count === 0) {
    container.innerHTML = '<p class="srl-empty-msg">Your cart is empty.</p><a href="#buy" class="srl-drawer-continue" data-action="continue-shopping">Continue shopping</a>';
    updateDrawerFooter(cart);
    return;
  }

  if (canPatchDrawerItems(container, cart)) {
    const rows = container.querySelectorAll('.srl-cart-item[data-line-key]');
    cart.items.forEach((item, index) => patchDrawerItemRow(rows[index], item));
    updateDrawerFooter(cart);
    return;
  }

  let itemsHtml = '';
  cart.items.forEach((item) => {
    itemsHtml += buildDrawerItemHtml(item);
  });

  container.innerHTML = itemsHtml;
  updateDrawerFooter(cart);
};

// 全局状态
let variantSingle = window.SRL_VARIANT_SINGLE_ID;
let variantBundle = window.SRL_VARIANT_BUNDLE_ID;
let priceSingleCents = window.SRL_PRICE_SINGLE_CENTS || 2499;
let priceBundleCents = window.SRL_PRICE_BUNDLE_CENTS || 6499;
let compareSingleCents = window.SRL_COMPARE_SINGLE_CENTS || 3999;
let compareBundleCents = window.SRL_COMPARE_BUNDLE_CENTS || 11997;
const MAX_SINGLE_QTY = 2;

function calcSavePercent(priceCents, compareCents) {
  if (!compareCents || compareCents <= priceCents) return null;
  return Math.round((1 - priceCents / compareCents) * 100);
}

let cartSingleQty = 0;
let cartBundleQty = 0; // 新增：追踪套餐数量，用于结账拦截判断
let currentQuantity = 1;
let currentSelection = 'single';
let isFetching = false;
let pageShowCount = 0;
let refreshCartTimer = null;

function fetchCartJson() {
  return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
    .then(async (res) => {
      if (!res.ok) {
        if (res.status === 429) throw new Error('429');
        throw new Error('Network response was not ok');
      }
      return res.json();
    });
}

function setBuyTipVisible(el, visible) {
  if (el) el.hidden = !visible;
}

window.clearCart = function() {
  if (isFetching) return Promise.resolve(false);

  return window.showConfirmModal({
    title: 'Clear your cart?',
    message: 'All items will be removed. You can add products again anytime.',
    confirmText: 'Clear cart',
    cancelText: 'Keep items'
  }).then((confirmed) => {
    if (!confirmed) return false;

    isFetching = true;
    setClearCartLoading(true);
    return fetch('/cart/clear.js', { method: 'POST' })
      .then(async (res) => {
        if (!res.ok) throw new Error('Clear cart failed');
        return res.json();
      })
      .then((cart) => {
        window.processCartState(cart);
        return true;
      })
      .catch((err) => {
        console.error('Clear cart failed:', err);
        return false;
      })
      .finally(() => {
        isFetching = false;
        setClearCartLoading(false);
      });
  });
};

window.upgradeToBundle = function(options = {}) {
  const { clearCart = true, closeDrawer = false, scrollToBuy = false } = options;
  if (isFetching) return Promise.resolve();

  isFetching = true;

  const cartPromise = clearCart
    ? fetch('/cart/clear.js', { method: 'POST' }).then(async (res) => {
        if (!res.ok) throw new Error('Clear cart failed');
        return res.json();
      })
    : Promise.resolve(null);

  return cartPromise
    .then((cart) => {
      if (cart) window.processCartState(cart);
      if (closeDrawer) window.closeDrawer();
      window.selectOption('bundle');
      if (scrollToBuy) {
        const buySection = document.getElementById('buy');
        if (buySection) buySection.scrollIntoView({ behavior: 'smooth' });
      }
    })
    .catch((err) => {
      console.error('Upgrade to bundle failed:', err);
    })
    .finally(() => { isFetching = false; });
};

window.processCartState = function(cart) {
  let sQty = 0;
  let bQty = 0;
  cart.items.forEach(item => {
    if (item.variant_id == variantSingle) sQty += item.quantity;
    if (item.variant_id == variantBundle) bQty += item.quantity;
  });
  cartSingleQty = sQty;
  cartBundleQty = bQty;
  updateCartUI();
  window.CartBubble.update(cart);
};

// 核心指挥调度中心 (统一受控组件)
function updateCartUI() {
  const vidInput = document.getElementById('variant-id-input');
  const addBtn = document.getElementById('add-to-cart-btn');
  const bnBtn = document.getElementById('buy-now-btn');
  const qdDisp = document.getElementById('qd');
  const qdInp = document.getElementById('qd-input');
  const qtyMinusBtn = document.getElementById('qty-minus');
  const qtyPlusBtn = document.getElementById('qty-plus');
  
  const optSingle = document.getElementById('option-single');
  const optBundle = document.getElementById('option-bundle');
  const tipFreeShipping = document.getElementById('tip-free-shipping');
  const tipLimitAmber = document.getElementById('tip-limit-amber');
  const tipLimitRed = document.getElementById('tip-limit-red');
  
  const displayNow = document.getElementById('display-price-now');
  const displayWas = document.getElementById('display-price-was');
  const displaySave = document.getElementById('display-price-save');

  if (!vidInput || !addBtn || !qdInp) return;

  // 1. 同步选项卡视觉
  if (currentSelection === 'single') {
    optSingle.classList.add('selected');
    optBundle.classList.remove('selected');
    vidInput.value = variantSingle;
    displayNow.textContent = formatDrawerMoney(priceSingleCents);
    displayWas.textContent = formatDrawerMoney(compareSingleCents);
    const savePct = calcSavePercent(priceSingleCents, compareSingleCents);
    displaySave.textContent = savePct ? `Save ${savePct}%` : '';
  } else {
    optBundle.classList.add('selected');
    optSingle.classList.remove('selected');
    vidInput.value = variantBundle;
    displayNow.textContent = formatDrawerMoney(priceBundleCents);
    displayWas.textContent = formatDrawerMoney(compareBundleCents);
    const savePct = calcSavePercent(priceBundleCents, compareBundleCents);
    displaySave.textContent = savePct ? `Save ${savePct}%` : '';
  }

  let isActionDisabled = false;

  // 2. 统一调度计算限购与提示
  if (currentSelection === 'single') {
    setBuyTipVisible(tipFreeShipping, false);
    const availableToAdd = MAX_SINGLE_QTY - cartSingleQty;
    
    if (availableToAdd <= 0) {
      setBuyTipVisible(tipLimitRed, true);
      setBuyTipVisible(tipLimitAmber, false);
      isActionDisabled = true;
      currentQuantity = 0;
      qtyMinusBtn.disabled = true;
      qtyPlusBtn.disabled = true;
    } else {
      setBuyTipVisible(tipLimitRed, false);
      if (currentQuantity >= availableToAdd) {
        currentQuantity = availableToAdd;
        setBuyTipVisible(tipLimitAmber, true);
        qtyPlusBtn.disabled = true;
      } else {
        setBuyTipVisible(tipLimitAmber, false);
        qtyPlusBtn.disabled = false;
        if (currentQuantity < 1) currentQuantity = 1;
      }
      isActionDisabled = false;
      qtyMinusBtn.disabled = currentQuantity <= 1;
    }
  } else {
    setBuyTipVisible(tipFreeShipping, false);
    setBuyTipVisible(tipLimitAmber, false);
    setBuyTipVisible(tipLimitRed, false);
    isActionDisabled = false;
    if (currentQuantity < 1) currentQuantity = 1;
    qtyMinusBtn.disabled = currentQuantity <= 1;
    qtyPlusBtn.disabled = false;
  }

  // 3. 执行最终物理更新 (置灰但不篡改文案)
  addBtn.disabled = isActionDisabled;
  bnBtn.disabled = isActionDisabled;
  
  if (!addBtn.classList.contains('is-loading') && !addBtn.classList.contains('is-success')) {
    addBtn.textContent = 'Add to Cart';
  }

  // 即使 disabled，也要显示单价，避免展示 $0.00
  const displayQty = currentQuantity === 0 ? 1 : currentQuantity;
  const currentUnitCents = currentSelection === 'single' ? priceSingleCents : priceBundleCents;
  
  qdDisp.textContent = currentQuantity;
  qdInp.value = currentQuantity;
  if (!bnBtn.classList.contains('is-loading')) {
    bnBtn.textContent = `Buy Now — ${formatDrawerMoney(currentUnitCents * displayQty)}`;
  }
}

function setBuyNowButtonState(state) {
  const bnBtn = document.getElementById('buy-now-btn');
  const addBtn = document.getElementById('add-to-cart-btn');
  if (!bnBtn) return;

  bnBtn.classList.remove('is-loading');
  bnBtn.removeAttribute('aria-busy');

  if (state === 'loading') {
    bnBtn.classList.add('is-loading');
    bnBtn.setAttribute('aria-busy', 'true');
    bnBtn.disabled = true;
    bnBtn.textContent = 'Redirecting…';
    if (addBtn) addBtn.disabled = true;
    return;
  }

  updateCartUI();
}

function refreshCartFromServer() {
  clearTimeout(refreshCartTimer);
  refreshCartTimer = setTimeout(() => {
    isFetching = false;
    setBuyNowButtonState('idle');
    setAddCartButtonState('idle');
    window.fetchCartSingleQty({ force: true });
  }, 100);
}

function setAddCartButtonState(state) {
  const addBtn = document.getElementById('add-to-cart-btn');
  const bnBtn = document.getElementById('buy-now-btn');
  if (!addBtn) return;

  addBtn.classList.remove('is-loading', 'is-success', 'loading');
  addBtn.removeAttribute('aria-busy');

  if (state === 'loading') {
    addBtn.classList.add('is-loading');
    addBtn.setAttribute('aria-busy', 'true');
    if (bnBtn) bnBtn.disabled = true;
    return;
  }

  if (state === 'success') {
    addBtn.classList.add('is-success');
    addBtn.textContent = 'Added';
    return;
  }

  addBtn.textContent = 'Add to Cart';
}

window.adj = function(d) {
  currentQuantity += d;
  updateCartUI();
};

window.selectOption = function(type) {
  currentSelection = type;
  currentQuantity = 1;
  updateCartUI();
};

window.fetchCartSingleQty = function(options = {}) {
  const { force = false } = options;
  if (isFetching && !force) return Promise.resolve();
  isFetching = true;
  return fetchCartJson()
    .then(cart => {
      window.processCartState(cart);
      return cart;
    })
    .catch(err => {
      if (err.message === '429') {
        console.warn('Shopify Dev Server 429: Too many requests for /cart.js');
      } else {
        console.error('Cart Fetch Error:', err);
      }
    })
    .finally(() => { isFetching = false; });
};

window.addEventListener('pageshow', () => {
  pageShowCount += 1;
  if (pageShowCount === 1) return;
  refreshCartFromServer();
});

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && pageShowCount > 1) {
    refreshCartFromServer();
  }
});

window.openDrawer = function() {
  const drawer = document.getElementById('srl-cart-drawer');
  if (drawer) {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
};
window.closeDrawer = function() {
  const drawer = document.getElementById('srl-cart-drawer');
  if (drawer) {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
};

/* --- 核心组件：全局 Upsell Modal 控制器 --- */
window.showUpsellModal = function(onAccept, onDecline) {
  const modal = document.getElementById('srl-upsell-modal');
  if (!modal) return;

  modal.classList.add('is-active');

  const acceptBtn = document.getElementById('srl-upsell-accept');
  const declineBtn = document.getElementById('srl-upsell-decline');
  const closeBtn = document.getElementById('srl-modal-close');
  const overlay = document.getElementById('srl-modal-overlay');

  const newAcceptBtn = acceptBtn.cloneNode(true);
  const newDeclineBtn = declineBtn.cloneNode(true);
  acceptBtn.parentNode.replaceChild(newAcceptBtn, acceptBtn);
  declineBtn.parentNode.replaceChild(newDeclineBtn, declineBtn);

  function closeModal() {
    modal.classList.remove('is-active');
    document.removeEventListener('keydown', onEsc);
  }

  function onEsc(e) {
    if (e.key === 'Escape') closeModal();
  }

  newAcceptBtn.addEventListener('click', () => {
    closeModal();
    if (onAccept) onAccept(newAcceptBtn);
  });

  newDeclineBtn.addEventListener('click', () => {
    closeModal();
    if (onDecline) onDecline();
  });

  if (closeBtn) closeBtn.onclick = closeModal;
  if (overlay) overlay.onclick = closeModal;
  document.addEventListener('keydown', onEsc);
};

window.showConfirmModal = function(options = {}) {
  const {
    title = '',
    message = '',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onConfirm,
    onCancel
  } = options;

  const modal = document.getElementById('srl-confirm-modal');
  if (!modal) return Promise.resolve(false);

  const titleEl = document.getElementById('srl-confirm-title');
  const messageEl = document.getElementById('srl-confirm-message');
  const acceptBtn = document.getElementById('srl-confirm-accept');
  const cancelBtn = document.getElementById('srl-confirm-cancel');
  const closeBtn = document.getElementById('srl-confirm-close');
  const overlay = document.getElementById('srl-confirm-overlay');

  if (!acceptBtn || !cancelBtn) return Promise.resolve(false);

  if (titleEl) titleEl.textContent = title;
  if (messageEl) messageEl.textContent = message;
  acceptBtn.textContent = confirmText;
  cancelBtn.textContent = cancelText;

  modal.classList.add('is-active');

  return new Promise((resolve) => {
    function closeModal() {
      modal.classList.remove('is-active');
      document.removeEventListener('keydown', onEsc);
    }

    function onEsc(e) {
      if (e.key === 'Escape') handleCancel();
    }

    function handleCancel() {
      closeModal();
      if (onCancel) onCancel();
      resolve(false);
    }

    function handleConfirm() {
      closeModal();
      if (onConfirm) onConfirm();
      resolve(true);
    }

    const newAcceptBtn = acceptBtn.cloneNode(true);
    const newCancelBtn = cancelBtn.cloneNode(true);
    acceptBtn.parentNode.replaceChild(newAcceptBtn, acceptBtn);
    cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);

    newAcceptBtn.addEventListener('click', handleConfirm);
    newCancelBtn.addEventListener('click', handleCancel);
    if (closeBtn) closeBtn.onclick = handleCancel;
    if (overlay) overlay.onclick = handleCancel;
    document.addEventListener('keydown', onEsc);
  });
};


document.addEventListener('DOMContentLoaded', () => {
  variantSingle = window.SRL_VARIANT_SINGLE_ID || variantSingle;
  variantBundle = window.SRL_VARIANT_BUNDLE_ID || variantBundle;
  if (window.SRL_PRICE_SINGLE_CENTS) priceSingleCents = window.SRL_PRICE_SINGLE_CENTS;
  if (window.SRL_PRICE_BUNDLE_CENTS) priceBundleCents = window.SRL_PRICE_BUNDLE_CENTS;
  if (window.SRL_COMPARE_SINGLE_CENTS) compareSingleCents = window.SRL_COMPARE_SINGLE_CENTS;
  if (window.SRL_COMPARE_BUNDLE_CENTS) compareBundleCents = window.SRL_COMPARE_BUNDLE_CENTS;

  const urlParams = new URLSearchParams(window.location.search);
  const shouldOpenCartDrawer = urlParams.get('cart') === 'open';

  if (urlParams.get('upgrade_bundle') === 'true') {
     window.selectOption('bundle');
     window.history.replaceState({}, document.title, window.location.pathname);
  }

  updateCartUI();
  syncLandingPrices();
  window.matchMedia('(max-width: 820px)').addEventListener('change', syncLandingPrices);
  window.fetchCartSingleQty().then(() => {
    if (shouldOpenCartDrawer) {
      window.openDrawer();
      window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
    }
  });

  const cartIcon = document.getElementById('cart-icon-bubble');
  const drawerClose = document.getElementById('srl-drawer-close');
  const drawerOverlay = document.getElementById('srl-drawer-overlay');

  if (cartIcon) cartIcon.addEventListener('click', (e) => { e.preventDefault(); window.openDrawer(); });
  if (drawerClose) drawerClose.addEventListener('click', window.closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', window.closeDrawer);

  const clearCartBtn = document.getElementById('srl-drawer-clear');
  if (clearCartBtn) clearCartBtn.addEventListener('click', () => window.clearCart());

  const checkoutBtn = document.getElementById('srl-btn-checkout');
  if (checkoutBtn) checkoutBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (checkoutBtn.disabled || isFetching) return;

    if (cartSingleQty === MAX_SINGLE_QTY && cartBundleQty === 0) {
      window.showUpsellModal(
        () => window.upgradeToBundle({ clearCart: true, closeDrawer: true, scrollToBuy: true }),
        () => { window.location.href = '/checkout'; }
      );
    } else {
      window.location.href = '/checkout';
    }
  });

  const qtyMinusBtn = document.getElementById('qty-minus');
  const qtyPlusBtn = document.getElementById('qty-plus');

  if (qtyMinusBtn) qtyMinusBtn.addEventListener('click', () => window.adj(-1));
  if (qtyPlusBtn) qtyPlusBtn.addEventListener('click', () => window.adj(1));

  const addBtn = document.getElementById('add-to-cart-btn');
  const bnBtn = document.getElementById('buy-now-btn');
  const form = document.getElementById('product-form');

  if (form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
    });
  }

  if (addBtn) addBtn.addEventListener('click', (event) => {
    event.preventDefault();
    if (addBtn.disabled || isFetching) return;

    const variantId = document.getElementById('variant-id-input').value;
    const qty = parseInt(document.getElementById('qd-input').value);
    
    if (!variantId || variantId === 'null') {
      showBuyError('Please select a product in theme settings.');
      return;
    }
    if (qty <= 0) return;

    hideBuyError();
    setAddCartButtonState('loading');
    isFetching = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(async (res) => {
      if (!res.ok) {
        if (res.status === 429) throw new Error('Too many requests. Please wait a few seconds and try again.');
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          throw new Error(json.description || 'Add to cart failed');
        } catch (e) {
          if (e.message && e.message !== 'Add to cart failed') throw e;
          throw new Error('Server error ' + res.status);
        }
      }
      return res.json();
    })
    .then(() => fetchCartJson())
    .then((cart) => {
      window.processCartState(cart);
    })
    .then(() => new Promise((resolve) => {
      setAddCartButtonState('success');
      setTimeout(resolve, 400);
    }))
    .then(() => {
      window.openDrawer();
    })
    .catch(error => {
      console.error('Cart Add Error:', error);
      if (error.message === '429') {
        showBuyError('Too many requests. Please wait a few seconds and try again.');
      } else {
        showBuyError(error.message || 'Add to cart failed. Please try again.');
      }
    })
    .finally(() => {
      setAddCartButtonState('idle');
      updateCartUI();
      isFetching = false;
    });
  });

  if (bnBtn) bnBtn.addEventListener('click', (event) => {
    event.preventDefault();
    if (bnBtn.disabled || isFetching || bnBtn.classList.contains('is-loading')) return;
    
    const variantId = document.getElementById('variant-id-input').value;
    const qty = parseInt(document.getElementById('qd-input').value);
    
    if (!variantId || variantId === 'null') {
      showBuyError('Please select a product in theme settings.');
      return;
    }
    if (qty <= 0) return;
    if (currentSelection === 'single' && (qty + cartSingleQty > MAX_SINGLE_QTY)) {
      showBuyError(`Maximum ${MAX_SINGLE_QTY} single lamps allowed per order.`);
      return;
    }
    if (!form) return;
    
    hideBuyError();
    isFetching = true;
    setBuyNowButtonState('loading');

    form.querySelectorAll('input[name="return_to"]').forEach((el) => el.remove());

    const returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    returnToInput.value = '/checkout';
    form.appendChild(returnToInput);
    form.submit();
  });

  // 抽屉内商品增删逻辑 (事件委托)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-action="continue-shopping"]')) {
      e.preventDefault();
      window.closeDrawer();
      return;
    }

    if (e.target.classList.contains('srl-dq-remove')) {
      e.preventDefault();
      if (isFetching) return;

      const key = e.target.getAttribute('data-key');
      const itemRow = e.target.closest('.srl-cart-item');
      isFetching = true;
      setDrawerLineLoading(itemRow, true);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(async (res) => {
        if (!res.ok) {
          if (res.status === 429) throw new Error('Too many requests. Please slow down.');
          throw new Error('Remove failed');
        }
        return res.json();
      })
      .then(cart => window.processCartState(cart))
      .catch(err => console.error('Remove Error:', err))
      .finally(() => {
        isFetching = false;
        setDrawerLineLoading(itemRow, false);
      });
      return;
    }

    if (e.target.classList.contains('srl-dq-btn')) {
      e.preventDefault();
      if (isFetching) return;
      
      const key = e.target.getAttribute('data-key');
      const vid = e.target.getAttribute('data-vid');
      const newQty = parseInt(e.target.getAttribute('data-qty'), 10);
      const itemRow = e.target.closest('.srl-cart-item');
      
      if (vid == variantSingle && newQty > MAX_SINGLE_QTY) {
         const notice = itemRow && itemRow.querySelector('.srl-buy-notice');
         if (notice) notice.hidden = false;
         return;
      }

      isFetching = true;
      setDrawerLineLoading(itemRow, true);
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(async (res) => {
         if (!res.ok) {
           if (res.status === 429) throw new Error('Too many requests. Please slow down.');
           throw new Error('Update failed');
         }
         return res.json();
      })
      .then(cart => {
         window.processCartState(cart); 
      })
      .catch(err => {
         console.error('Change Error:', err);
      })
      .finally(() => { 
         isFetching = false;
         setDrawerLineLoading(itemRow, false);
      });
    }

    const switchBtn = e.target.closest('[data-action="switch-bundle"]');
    if (switchBtn) {
      e.preventDefault();
      if (isFetching) return;

      const origText = switchBtn.innerText;
      switchBtn.disabled = true;
      switchBtn.innerText = 'Switching…';

      if (window.location.pathname === '/cart') {
        window.location.href = '/?upgrade_bundle=true#buy';
        return;
      }

      const inDrawer = !!switchBtn.closest('#srl-cart-drawer');
      window.upgradeToBundle({
        clearCart: true,
        closeDrawer: inDrawer,
        scrollToBuy: inDrawer
      }).finally(() => {
        switchBtn.disabled = false;
        switchBtn.innerText = origText;
      });
      return;
    }
  });
});